import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";


export const encryptPayload = ( payload ) => {

    const userId = process.env.REACT_APP_USER_ID;
    const guestKey = process.env.REACT_APP_GUEST_KEY;

    let secretPhrase = CryptoJS.lib.WordArray.random(16);
    let salt = CryptoJS.lib.WordArray.random(128 / 8);

    let aesKey = CryptoJS.PBKDF2(secretPhrase.toString(), salt, {
        keySize: 128 / 32,
        iterations: 65536
    });


    //define initialization vector - 1st 16 chars of userId
    let initVector = CryptoJS.enc.Utf8.parse(userId.slice(0, 16));
    // let initVectorStr = initVector.toString();

    let aesOptions = {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: initVector
    };

    let encryptedPayload = CryptoJS.AES.encrypt(JSON.stringify(payload), aesKey, aesOptions);

    //encrypt AES key with RSA public key
    let rsaEncrypt = new JSEncrypt();
    rsaEncrypt.setPublicKey(guestKey);
    let rsaEncryptedAesKey = rsaEncrypt.encrypt(encryptedPayload.key.toString());

    let encryptedObject = {
        guid: userId,
        key: rsaEncryptedAesKey,
        encryption: encryptedPayload.toString()
    };

    return encryptedObject;

};
